
<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="10">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Login</h1>
                  <p class="text-muted">Connexion avec votre compte HEIG-VD</p>
                  <CAlert v-if="loginError" color="warning">Erreur de connexion</CAlert>
                  <CInput
                    placeholder="Utilisateur (prénom.nom)"
                    autocomplete="username"
                    v-model="username"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Mot de passe"
                    type="password"
                    autocomplete="password"
                    v-model="password"
                    @keyup.enter.native="authenticate"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="info" class="px-4" @click="authenticate" >Login</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="info"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>TBFI</h2>
                <p>TBFI est le tableau de bord finance pour la gestion des instituts Ra&amp;D de la HEIG-VD.</p>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      loginError: false
    }
  },
  created () {
    // Delete JWT tokens. This is required since the Logout menu redirects to the login page
    this.$cookies.remove('jwt_access')
    this.$cookies.remove('jwt_refresh')

  },
  methods: {
    authenticate() {
      axios.post('webapi/token-authenticate', {
            username: this.username,
            password: this.password
          })
          .then(result => {
            let now = new Date()
            let tomorrowNight = new Date(now.getFullYear(), now.getMonth(), now.getDate()+1, 3,0,0)
            this.$cookies.set('jwt_access',result.data.access, tomorrowNight)
            this.$cookies.set('jwt_refresh',result.data.refresh, tomorrowNight)
            this.$router.push('/')
          })
          .catch(error => {this.loginError = true})
    }
  }
}
</script>
